import { render, staticRenderFns } from "./ModalBoardReportCreator.vue?vue&type=template&id=33a38d8a&"
import script from "./ModalBoardReportCreator.vue?vue&type=script&lang=js&"
export * from "./ModalBoardReportCreator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports